import { ChangeEvent, ReactNode } from 'react';
import { Box, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ViolationsAutocomplete from 'components/autocompletes/ViolationsAutocomplete';
import AuturaTextField from 'components/inputs/AuturaTextField';
import SettingsSection from 'components/layout/SettingsSection';
import { RuleTypeFormProps } from './RuleForm';

const TagRuleForm = ({
  rule,
  setRule,
  violations,
  handleAutoCompleteChange,
}: RuleTypeFormProps): ReactNode => {
  const { t } = useTranslation();

  const handleTagHoursChange = (e: ChangeEvent<HTMLInputElement>) => {
    const formattedValue = e.target.value.replace(/[^0-9]/g, '');
    setRule({
      ...rule,
      data: { ...rule.data, tagHours: Number(formattedValue) },
    });
  };

  return (
    <SettingsSection
      title={t('labels.tag_rule_details', { ns: 'rules' })}
      divider={false}
    >
      <Grid container width='100%' spacing={1.5}>
        <Grid
          size={{
            xs: 12,
            lg: 3,
          }}
        >
          <AuturaTextField
            required
            name='tagHours'
            label={t('rule.data.tagHours', { ns: 'entities' })}
            value={rule.data?.tagHours || ''}
            onChange={handleTagHoursChange}
          />
        </Grid>
        <Grid size={12}>
          <ViolationsAutocomplete
            selected={rule.data.violations}
            handleChange={handleAutoCompleteChange}
            loading={!rule}
            options={violations}
            required
          />
        </Grid>
      </Grid>
    </SettingsSection>
  );
};

export default TagRuleForm;
